var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "22px",
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Document icon/PDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5441176,20.3076923 L1.45588235,20.3076923 C0.651821029,20.3076923 0,19.6582418 0,18.8571429 L0,1.45054945 C0,0.649433407 0.651821029,0 1.45588235,0 L11.25,0 L18,6.72527473 L18,18.8571429 C18,19.6582418 17.3481618,20.3076923 16.5441176,20.3076923 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u270F\\uFE0F-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-34.000000, -1669.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-icon/PDF",
    transform: "translate(34.333333, 1669.833333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5441176,20.3076923 L1.45588235,20.3076923 C0.651821029,20.3076923 0,19.6582418 0,18.8571429 L0,1.45054945 C0,0.649433407 0.651821029,0 1.45588235,0 L11.25,0 L18,6.72527473 L18,18.8571429 C18,19.6582418 17.3481618,20.3076923 16.5441176,20.3076923 Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,6.72527473 L12.7058824,6.72527473 C11.9018382,6.72527473 11.25,6.07584396 11.25,5.27472527 L11.25,0 L18,6.72527473 Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "adobe_acrobat_logo_icon_169638",
    transform: "translate(5.076923, 6.923077)",
    stroke: "#D3243C",
    strokeWidth: 0.5312
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.96270806,0.838760377 C3.91842818,-0.45746045 2.91361565,-0.150460781 2.95448938,1.07071568 C3.01579997,2.53749188 3.56759533,2.96046921 4.38506994,3.99062365 C5.41372548,5.2936667 6.19032636,6.02705479 6.82046303,6.19761017 C7.76396497,6.45003212 8.28510504,5.65183298 7.3654461,5.25273341 C6.44578717,4.85363384 4.81083796,4.97984481 3.85711759,5.12652243 C2.30732198,5.37553327 1.19351283,5.81897724 0.331758347,6.78773175 C-0.424405663,7.62686418 0.246604743,8.25450795 1.00276875,7.52453096 C1.69421602,6.87642055 2.6172811,5.08558914 2.99536311,4.24986782 C3.49947245,3.13784679 4.06489238,2.14862563 3.95930191,0.719371617 L3.96270806,0.838760377 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.7290ecc23f117c940819b0a182a06dd9.svg";
export { ForwardRef as ReactComponent };